export const getDriveImage = (url, size = 1200) => {
  const match = url?.match(/\/d\/([a-zA-Z0-9_-]+)/);
  const id = match ? match[1] : null;
  return id
    ? `https://drive.google.com/thumbnail?id=${id}&sz=w${size}`
    : null;
};
